export default __webpack_public_path__ + "static/media/earth-globe.a621c22d.png";